export enum RecipientType {
  Contact,
  Group,
  User,
}
